export default {
    namespaced: true,

    state: () => {
        return {
            loading: false,
            shelfs: [],
        }
    },

    getters: {
        loading(state) {
            return state.loading;
        },

        shelfs(state) {
            return state.shelfs.map((item, sl) => {
                item.sl = sl + 1;
                return item;
            });
        }
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading
        },

        setShelf(state, shelfs) {
            state.shelfs = shelfs
        },
    },

    actions: {
        async getShelfs(context) {
            context.commit('setLoading', true);
        
            await axios.get(`${this.state.host}/get-shelfs`, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                context.commit('setShelf', res.data.shelfs);
            })
            .catch(error => this.dispatch('snackbar/error', error))

            context.commit('setLoading', false);
        },

        async saveShelf(context, payload) {
            let isSuccess = false;

            let url = '';
            if(payload.id != null) {
                url = 'update-shelf';
            } else {
                url = 'add-shelf';
                delete payload.id
            }

            await axios.post(`${this.state.host}/${url}`, payload, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getShelfs');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        },

        async deleteShelf(context, id) {
            let isSuccess = false;

            await axios.delete(`${this.state.host}/delete-shelf/${id}`, {
                headers: {
                    'Authorization': this.getters['authorized/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getShelfs');
            })
            .catch(error => { 
                isSuccess = false;
                this.dispatch('snackbar/error', error);
            })

            return isSuccess;
        },
    }
}
